import { z } from 'zod';

export const CampaignIdSchema = z.number();
export type CampaignId = z.infer<typeof CampaignIdSchema>;
